import { IDemo, E3DSessionNameVals } from 'types'
import { connectedHealth, managedVenues, videoSecurity } from './sessions/index'

export interface ISession {
  id: string // Horan - this is a horrible way to do this, but under tight deadline
  sceneKey?: E3DSessionNameVals
  nameKey: string
  image: string
  bluejeans?: string
  side: {
    category: string
    header: string
    shortHeader: string
    schedule: string
    body: string
    speakers?: string[]
    chatBody: string
  }
  videoSrc: string
}

// Sessions are really just demos for PS1
export const Sessions: IDemo[] = [videoSecurity, connectedHealth, managedVenues]

// dummy code for now - using this so I (Jesse) don't have to undo all the session logic in the game wrapper even though we're not using it
export const OldSessions: ISession[] = [
  {
    id: '4ab7c286-2a47-428c-8ca0-4cc765e153dd',
    nameKey: 'drones',
    sceneKey: E3DSessionNameVals.drones,
    image: '',
    bluejeans: 'https://primetime.bluejeans.com/a2m/live-event/qadufrfr',
    side: {
      category: 'Breakout Session',
      header: 'Drones services, Aerial Applications',
      shortHeader: 'Drones',
      schedule: 'Session will begin 2:25 pm ET.',
      speakers: [],
      body: '',
      chatBody: ''
    },
    videoSrc: 'https://d1oc551tl862q5.cloudfront.net/e2-healthcare.mp4'
  }
]

export const findSessionById = (id: string) => {
  for (let key in Sessions) {
    const session = Sessions[key]
    if (session.id === id) {
      return session
    }
  }
}
